import React, { useState } from 'react';
import {
    Formik,
    Form,
    Field,
    ErrorMessage
} from 'formik';

import { observer } from 'mobx-react-lite';
import { IUserForgetPasswordForm } from '../../../app/models/user';
import { Box, Button, FormControl, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import { forgetPasswordSchema } from '../../../app/common/formValidations/validationSchemes';
import agent from '../../../app/api/agent';

const style = (isMobile: boolean) => {
    return ({
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 400 : 360,
        bgcolor: '#DAE5F1',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    })
};

export default observer(function Login() {
    const [resetPasswordMessage, setResetPasswordMessage] = useState('');
    const initialValues: IUserForgetPasswordForm = { email: '' };
    const handleResetPasswordEmailSend = (email: string) => {
        agent.Account.resetPasswordEmail(email).then(() => {
            setResetPasswordMessage('A new email has been sent your way');
        }).catch((error) => console.log(error));
    }

    const matches = useMediaQuery('(min-width:900px)');

    return (
        <Box sx={style(matches)}>
            <Typography variant='h4' textAlign='center'>Forgot Password?</Typography>
            <Formik
                initialValues={initialValues}
                validationSchema={forgetPasswordSchema}
                onSubmit={(values, { setSubmitting }) => {
                    handleResetPasswordEmailSend(values.email);
                    setSubmitting(false);
                }}
            >
                {({ values,
                    handleChange,
                    handleBlur,
                    isSubmitting, }) => {
                    return (
                        <Form autoComplete='off'>
                            <Stack direction='column' spacing={2} m={2} alignItems='center'>
                                <FormControl fullWidth>
                                    <Field
                                        type="text"
                                        component={TextField}
                                        id="email"
                                        name="email"
                                        placeholder="Email"
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.email}
                                        variant="outlined"
                                    />
                                    <ErrorMessage name="email" component="div" />
                                </FormControl>
                                <Stack
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    spacing={2}
                                    pt={2}
                                >
                                    <Button size="medium" type='submit' variant="contained" color="primary" >Send Email</Button>
                                </Stack>
                            </Stack>
                        </Form>
                    );
                }}
            </Formik>
            {resetPasswordMessage !== '' &&
                <p>{resetPasswordMessage}</p>
            }
        </Box>
    );
});